import React, { Component } from 'react'
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import './Overview.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faGraduationCap, faBookOpen, faUser, faBuilding, faLightbulb, faCogs } from '@fortawesome/free-solid-svg-icons';
import { departments } from '../../../config/Department';
import { Util } from '../../../config/Util';
import assessmentIcon from '../../../assets/Dashboard/assessment.png'
import trainingIcon from '../../../assets/Dashboard/training.png'
import userDataIcon from '../../../assets/Dashboard/user-data.png'
import communicationIcon from '../../../assets/Dashboard/communication.png'
import activeUserIcon from '../../../assets/Dashboard/active-user.png'
import assignedIcon from '../../../assets/Dashboard/total-assigned.png'
import completedIcon from '../../../assets/Dashboard/total-completed.png'


export default class Overview extends Component {

  constructor() {
    super();
    this.state = {
      loader: false,
      serverData: {
        noOfUsers: 0,
        noOfGroups:0,
        assessment: {
          totalNo: 0,
          assigned: 0,
          completed: 0
        },
        training: {
          totalNo: 0,
          assigned: 0,
          completed: 0
        },
        communication: {
          totalNo: 0,
          assigned: 0,
          completed: 0
        }
      },
      ibtikar: {
        submissions: {
          total: 0,
          statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 }
        },
        implementations: {
          total: 0,
          statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 }
        }
      }
    }


  }


  componentDidMount() {
    this.setState({ loader: true });

    const adminOverviewPromise = axios.get(API.adminOverview).then((res) => {
      if (res.status === 200 && res.data) {
        this.setState({ serverData: res.data });
      }
      return this.loadMasterData();
    }).catch((er) => {
      console.error("Error fetching admin overview:", er);
    });

    const ibtikarPromise = this.fetchIbtikarOverview();

    Promise.all([adminOverviewPromise, ibtikarPromise]).finally(() => {
      this.setState({ loader: false });
    });
  }

  loadMasterData = () => {
    return axios.get(API.getUserMasterData).then((resp) => {
      if (resp.status === 200 && resp.data) {
        localStorage.setItem("ElmaamProjects", JSON.stringify(resp.data.projects));
        localStorage.setItem("ElmaamLevels", JSON.stringify(resp.data.levels));
      }
    }).catch((er) => {
      console.error("Error loading master data:", er);
    });
  }

  fetchIbtikarOverview = async () => {
    const auth = Util.getFromSession("auth");
    const userId = auth && auth.id ? auth.id : Util.userId;
    if (!userId) return;

    try {
      const resp = await axios.get(API.myIdeas, { params: { userId } });
      if (resp && resp.data && resp.data.status === 'S' && Array.isArray(resp.data.ideas)) {
        const ideas = resp.data.ideas;
        
        const submissions = ideas.filter(idea => Number(idea.empUserId) === Number(userId));
        const implementations = ideas.filter(idea => Number(idea.assignee) === Number(userId));
        
        this.setState({
          ibtikar: {
            submissions: {
              total: submissions.length,
              statuses: this.getIdeasStatusCount(submissions)
            },
            implementations: {
              total: implementations.length,
              statuses: this.getIdeasStatusCount(implementations)
            }
          }
        });
      }
    } catch (err) {
      console.error("Error fetching Ibtikar overview:", err);
    }
  }

  getIdeasStatusCount = (ideasList) => {
    const counts = {
      open: 0,
      review: 0,
      implementation: 0,
      completed: 0,
      rejected: 0
    };
    
    ideasList.forEach(idea => {
      if (idea && idea.status) {
        const status = String(idea.status).toLowerCase();
        if (status.includes('open')) {
          counts.open++;
        } else if (status.includes('review')) {
          counts.review++;
        } else if (status.includes('implementation')) {
          counts.implementation++;
        } else if (status.includes('completed')) {
          counts.completed++;
        } else if (status.includes('rejected')) {
          counts.rejected++;
        } else {
          if (!counts[status]) {
            counts[status] = 0;
          }
          counts[status]++;
        }
      }
    });
    return counts;
  }
  render() {
    const ibtikar = this.state.ibtikar || {
      submissions: { total: 0, statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 } },
      implementations: { total: 0, statuses: { open: 0, review: 0, implementation: 0, completed: 0, rejected: 0 } }
    };
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='HOME'></input>
            </span>

          </div>
        </div>
        <div className='mt-4'>
          <div className='row m-auto admin-overview'>
            <div className="card col-md-6" >
              <div className="card-body assessment-box">
                <div className="card-title mb-2">
                  <div className='card-icon'>
                    <img src={assessmentIcon} />
                  </div>
                  <h4 style={{color: '#000'}}>ASSESSMENT</h4>
                </div>
                {/* <p className="card-text ">{this.serverData.assessments.totalNo}</p> */}
                <div className='card-detail-block-admin'>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={activeUserIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total active</p>
                      <h6>{this.state.serverData.assessment.totalNo}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={assignedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Assigned To</p>
                      <h6>{this.state.serverData.assessment.assigned}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={completedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Completed</p>
                      <h6>{this.state.serverData.assessment.completed}</h6>
                    </div>
                  </div>
                </div>
                {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
              </div>
            </div>
            <div className="card col-md-6" >
              <div className="card-body training-box">
                <div className="card-title mb-2">
                  <div className='card-icon'>
                    <img src={trainingIcon} />
                  </div>
                  <h4 style={{color: '#000'}}>TRAINING</h4>
                </div>
                <div className='card-detail-block-admin'>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={activeUserIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total active</p>
                      <h6>{this.state.serverData.training.totalNo}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={assignedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Assigned To</p>
                      <h6>{this.state.serverData.training.assigned}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={completedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Completed</p>
                      <h6>{this.state.serverData.training.completed}</h6>
                    </div>
                  </div>
                </div>
                {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
              </div>
            </div>

          </div>
        </div>

        <div className='mt-4 mb-5'>
          <div className='row m-auto admin-overview'>
            <div className="card col-md-6" >
              <div className="card-body communication-box">
                <div className="card-title mb-2">
                  <div className='card-icon'>
                    <img src={communicationIcon} />
                  </div>
                  <h4 style={{color: '#000'}}>COMMUNICATION</h4>
                </div>
                {/* <p className="card-text overdue">9</p> */}
                <div className='card-detail-block-admin'>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={activeUserIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total active</p>
                      <h6>{this.state.serverData.communication.totalNo}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={assignedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Assigned To</p>
                      <h6>{this.state.serverData.communication.assigned}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={completedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Completed</p>
                      <h6>{this.state.serverData.communication.completed}</h6>
                    </div>
                  </div>
                  {/* <p>Total active  : {this.state.serverData.communication.totalNo}</p>
                  <p>Total Assigned To : {this.state.serverData.communication.assigned}</p>
                  <p>Total Completed  : {this.state.serverData.communication.completed}</p> */}
                </div>
                {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
              </div>
            </div>
            
            <div className="card col-md-6" >
              <div className="card-body user-stat-box">
                <div className="card-title mb-2">
                  <div className='card-icon'>
                    <img src={userDataIcon} />
                  </div>
                  <h4 style={{color: '#000'}}>USER DATA</h4>
                </div>
                <div className='card-detail-block-admin'>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={activeUserIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Users</p>
                      <h6>{this.state.serverData.noOfUsers}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={assignedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Departments</p>
                      <h6>{this.state.serverData.noOfGroups}</h6>
                    </div>
                  </div>
                  <div className='detail-block'>
                    <div className='detail-icon'>
                      <img src={completedIcon} alt='' />
                    </div>
                    <div className='detail-count-section'>
                      <p>Total Completed</p>
                      <h6>{this.state.serverData.training.completed}</h6>
                    </div>
                  </div>
                  {/* <div className='user-sect'>
                    <p> <span><FontAwesomeIcon icon={faUser} /></span>Total Users  : {this.state.serverData.noOfUsers}</p>
                    <p> <span><FontAwesomeIcon icon={faBuilding} /></span>Total Departments : {departments.list.length}</p>
                  </div> */}

                </div>
                {/* <a href="#" className="btn btn-primary">Go somewhere</a> */}
              </div>
            </div>
          </div>

          {/* Ibtikar Overview Section */}
          <div className="ibtikar-section-title">
            <span>Ibtikar Overview</span>
          </div>

          <div className="ibtikar-row">
            {/* Submissions Card */}
            <div className="ibtikar-card">
              <div className="ibtikar-card-header">
                <h5 className="ibtikar-card-title">
                  <FontAwesomeIcon icon={faLightbulb} className="me-2 text-warning" />
                  My Submissions
                </h5>
                <span className="ibtikar-total-badge">
                  Total: {ibtikar.submissions.total}
                </span>
              </div>
              <div className="ibtikar-status-grid">
                <div className="ibtikar-status-item status-open">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.open || 0}</span>
                  <span className="ibtikar-status-label">Open</span>
                </div>
                <div className="ibtikar-status-item status-review">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.review || 0}</span>
                  <span className="ibtikar-status-label">Review</span>
                </div>
                <div className="ibtikar-status-item status-implementation">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.implementation || 0}</span>
                  <span className="ibtikar-status-label">Implementation</span>
                </div>
                <div className="ibtikar-status-item status-completed">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.completed || 0}</span>
                  <span className="ibtikar-status-label">Completed</span>
                </div>
                <div className="ibtikar-status-item status-rejected">
                  <span className="ibtikar-status-val">{ibtikar.submissions.statuses.rejected || 0}</span>
                  <span className="ibtikar-status-label">Rejected</span>
                </div>
              </div>
            </div>

            {/* Implementation Card */}
            <div className="ibtikar-card">
              <div className="ibtikar-card-header">
                <h5 className="ibtikar-card-title">
                  <FontAwesomeIcon icon={faCogs} className="me-2 text-primary" />
                  My Assigned Implementations
                </h5>
                <span className="ibtikar-total-badge">
                  Total: {ibtikar.implementations.total}
                </span>
              </div>
              <div className="ibtikar-status-grid">
                <div className="ibtikar-status-item status-open">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.open || 0}</span>
                  <span className="ibtikar-status-label">Open</span>
                </div>
                <div className="ibtikar-status-item status-review">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.review || 0}</span>
                  <span className="ibtikar-status-label">Review</span>
                </div>
                <div className="ibtikar-status-item status-implementation">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.implementation || 0}</span>
                  <span className="ibtikar-status-label">Implementation</span>
                </div>
                <div className="ibtikar-status-item status-completed">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.completed || 0}</span>
                  <span className="ibtikar-status-label">Completed</span>
                </div>
                <div className="ibtikar-status-item status-rejected">
                  <span className="ibtikar-status-val">{ibtikar.implementations.statuses.rejected || 0}</span>
                  <span className="ibtikar-status-label">Rejected</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}
